import LazyLoad from 'vanilla-lazyload';
import { lazyLoadSettings } from './lazyload-settings';

function pagination() {
  const onPaginationBtnClick = e => {
    let target = e.currentTarget;
    let page = parseInt(target.dataset.page);
    let url = `${target.dataset.pageurl}?p=${page}`;
    const paginationLoader = document.querySelector('.js-pagination-loader');
    paginationLoader.classList.remove('d-none');

    fetch(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.view) {
          page++;
          target.dataset.page = page;
          const resultList = document.querySelector('.js-resultlist');
          resultList.insertAdjacentHTML('beforeend', data.view);
          const lazyLoad = new LazyLoad(lazyLoadSettings);
          paginationLoader.classList.add('d-none');

          if (data.hideButton) {
            target.classList.add('d-none');
          }
        } else {
          target.classList.add('d-none');
        }
      })
      .catch(function (err) {
        console.log('Fetch Error: ', err);
      });
  };

  const init = () => {
    const paginationBtn = document.querySelector('.js-pagination-btn');
    if (paginationBtn) {
      const srOnly = document.querySelector('.js-pagination-sr-only');
      if (srOnly) srOnly.classList.add('sr-only');

      paginationBtn.addEventListener('click', onPaginationBtnClick);
    }
  };

  init();
}
export default pagination;
